import Seo from "@/components/Seo";
import { LineMask, FadeUp } from "@/components/Reveal";

const Datenloeschung = () => (
  <>
    <Seo
      title="Datenlöschung | DIMEDIAL Studio Herford"
      description="Anleitung zur Löschung Ihrer über Facebook und Instagram verbundenen Daten bei DIMEDIAL Studio."
      path="/datenloeschung"
    />
    <div className="shell pt-44 pb-28 md:pb-40" data-testid="datenloeschung-page">
      <h1 className="font-display font-semibold uppercase tracking-tight leading-[0.95] text-5xl md:text-7xl lg:text-8xl text-paper mb-16 md:mb-24">
        <LineMask>Datenlöschung<span className="text-gold">.</span></LineMask>
      </h1>

      <div className="max-w-2xl space-y-14">
        <FadeUp>
          <section aria-label="Welche Daten betroffen sind">
            <h2 className="label-text mb-5">Welche Daten betroffen sind</h2>
            <p className="text-lg text-paper/90 leading-relaxed">
              Wenn Sie Ihr Facebook-Seiten- oder Instagram-Business-Konto mit DIMEDIAL verbinden,
              speichern wir ausschließlich die für die Veröffentlichung nötigen Angaben: das
              Zugriffstoken, die Referenzen Ihrer Facebook-Seite(n) und des verknüpften
              Instagram-Kontos sowie die von Ihnen ausgelösten Beiträge. Diese Daten können auf
              Wunsch gelöscht werden.
            </p>
          </section>
        </FadeUp>

        <FadeUp delay={0.05}>
          <section aria-label="Löschung beantragen">
            <h2 className="label-text mb-5">So beantragen Sie die Löschung</h2>
            <p className="text-lg text-paper/90 leading-relaxed">
              Senden Sie eine E-Mail mit dem Betreff „Datenlöschung“ an{" "}
              <a
                href="mailto:info@dimedial.de?subject=Datenl%C3%B6schung"
                data-testid="datenloeschung-email"
                className="text-gold hover:underline transition-colors duration-500"
              >
                info@dimedial.de
              </a>
              . Bitte nennen Sie darin Ihren Namen und die betroffene Facebook-Seite bzw. das
              Instagram-Konto (oder die E-Mail-Adresse Ihres DIMEDIAL-Kontos), damit wir die
              Zuordnung sicher vornehmen können.
            </p>
            <p className="text-lg text-paper/90 leading-relaxed mt-5">
              Wir bestätigen den Eingang Ihrer Anfrage und löschen die gespeicherten
              Meta-Verbindungsdaten. Die Bearbeitung erfolgt manuell durch unser Team – es handelt
              sich nicht um eine automatische Sofortlöschung.
            </p>
          </section>
        </FadeUp>

        <FadeUp delay={0.1}>
          <section aria-label="Verbindung selbst trennen">
            <h2 className="label-text mb-5">Verbindung sofort selbst trennen</h2>
            <p className="text-lg text-paper/90 leading-relaxed">
              Angemeldete Kundinnen und Kunden können die Facebook-/Instagram-Verbindung jederzeit
              selbst im Kundenportal im Bereich „Social“ trennen. Dadurch werden die gespeicherten
              Zugriffstoken und Konto-Verknüpfungen umgehend aus unserem System entfernt.
            </p>
          </section>
        </FadeUp>

        <FadeUp delay={0.15}>
          <section aria-label="Verantwortlicher">
            <h2 className="label-text mb-5">Verantwortlicher</h2>
            <p className="text-lg text-paper/90 leading-relaxed">
              Dimedial.de<br />
              Mindener Str. 52<br />
              32049 Herford<br />
              E-Mail:{" "}
              <a
                href="mailto:info@dimedial.de"
                data-testid="datenloeschung-email-kontakt"
                className="hover:text-gold transition-colors duration-500"
              >
                info@dimedial.de
              </a>
            </p>
          </section>
        </FadeUp>
      </div>
    </div>
  </>
);

export default Datenloeschung;
